import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-grid gfu-grid--gutter-columns" }
const _hoisted_2 = {
  class: "gfu-grid__cell gfu-1of1 gfu-6of12--m",
  "data-qa": "adyen-form:Name"
}
const _hoisted_3 = {
  class: "gfu-grid__cell gfu-1of1 gfu-6of12--m",
  "data-qa": "adyen-form:Email"
}
const _hoisted_4 = {
  class: "gfu-grid__cell gfu-1of1 gfu-6of12--m _fc",
  "data-qa": "adyen-form:CardNumber"
}
const _hoisted_5 = { class: "gfu-grid__cell gfu-1of1 gfu-6of12--m" }
const _hoisted_6 = { class: "gfu-grid gfu-grid--gutter-columns" }
const _hoisted_7 = { class: "gfu-grid__cell gfu-1of2 gfu-6of12--m" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_text_field = _resolveComponent("text-field")
  const _component_field = _resolveComponent("field")

  return (_openBlock(), _createElementBlock("fieldset", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_text_field, {
        modelValue: $data.holderName,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.holderName) = $event)),
        class: "_mt-0",
        name: "holderName",
        "display-name": _ctx.Resources.Checkout.CheckoutCreditCardCardholderNameLabel
      }, null, 8 /* PROPS */, ["modelValue", "display-name"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_text_field, {
        modelValue: $data.email,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.email) = $event)),
        class: "_mt-0",
        name: "email",
        "display-name": _ctx.Resources.Checkout.CheckoutCreditCardCardholderEmailLabel
      }, null, 8 /* PROPS */, ["modelValue", "display-name"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_field, {
        "display-name": _ctx.Resources.Checkout.CheckoutCreditCardNumberLabel,
        name: "encryptedCardNumber"
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createElementVNode("div", {
            class: "gfu-field__input",
            "data-cse": "encryptedCardNumber"
          }, null, -1 /* CACHED */)
        ]))]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["display-name"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_field, {
            "display-name": _ctx.Resources.Checkout.CheckoutCreditCardExpiryDateLabel,
            name: "encryptedExpiryDate",
            "data-qa": "adyen-form:ExpiryDate"
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createElementVNode("div", {
                class: "gfu-field__input",
                "data-cse": "encryptedExpiryDate"
              }, null, -1 /* CACHED */)
            ]))]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["display-name"])
        ])
      ])
    ])
  ]))
}